import { color, font, query, space } from '@design/templateFns';
import styled from 'styled-components';

export const DrawerHeader = styled.h2`
  ${font('headline-xxs')};
  padding: 0;
  margin-bottom: ${space('x6')};

  @media screen and (${query.atLeast('tablet')}) {
    ${font('headline-sm')};
    margin-bottom: ${space('x7')};
  }
`;

export const DrawerSubheader = styled.h4`
  ${font('body-sm')};
  padding: 0;
  margin-bottom: ${space('sm')};

  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-md')};
  }
`;
export const SectionColumns = styled.ul`
  @media screen and (${query.atLeast('tablet')}) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: ${space('xl')};
  }
  @media screen and (${query.atLeast('desktop')}) {
    column-gap: ${space('x6')};
  }
`;
export const SectionColumnItem = styled.li``;
export const Sections = styled.ul``;
export const Section = styled.div`
  padding-bottom: ${space('lg')};

  &:last-child {
    padding-bottom: 0;
  }
`;
export const SectionList = styled.ul`
  ${font('body-sm-light')};
  color: ${color('gray4')};
  list-style: disc;
  padding-left: ${space('x5')};

  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-md-light')};
  }
`;
export const SectionListNoColumn = styled(SectionList)`
  column-count: 3;
`;

export const FlexDrawer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
`;

export const FlexDivFourColumn = styled.div`
  width: 25%;
  margin-bottom: 15px;
  @media screen and (${query.below('tablet')}) {
    width: 50%;
  }
`;

export const Item = styled.li`
  font-weight: 300;
  font-size: 16px;
  color: #757575;
  list-style: disc;
  @media screen and (${query.below('tablet')}) {
    font-size: 14px;
  }
`;

export const ExteriorFeatures = styled.div`
  max-width: 500px;
  min-width: 300px;
`;

export const FlexDivTwoColumn = styled.div`
  width: 50%;
  margin-bottom: 15px;
  @media screen and (${query.below('tablet')}) {
    width: 50%;
  }
`;

export const FlexDivHeder = styled.div`
  font-weight: 400;
  color: #242323;
  font-size: 16px;
`;

export const FlexTermDrawer = styled.div<{
  $isLastTerm: boolean;
}>`
  margin-bottom: ${({ $isLastTerm }) => ($isLastTerm ? '0' : '16px')};
`;

export const FlexTermsHeader = styled(FlexDivHeder)`
  width: 100%;
`;

export const FlexDivContent = styled.div`
  width: 80%;
  font-weight: 300;
  color: #757575;
  font-size: 16px;
`;

export const FlexTermsContent = styled(FlexDivContent)`
  width: 100%;
  margin-top: 4px;
  white-space: pre-line;
`;

export const TaxDrawer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: nowrap;

  .tax-block:nth-child(1) {
    width: 500px;
  }
  .tax-block:nth-child(2) {
    width: 100%;
  }
  .header {
    margin-bottom: 30px;
    border-bottom: 1px solid #e5e5e5;
  }
  .item {
    display: flex;
    margin-bottom: 10px;
  }
  .item span {
    width: 100px;
  }
  .item .value {
    font-weight: 300;
    color: #757575;
    width: 100%;
  }
  .item .value.total {
    font-weight: 700;
  }
  @media screen and (${query.below('tablet')}) {
    .tax-block:nth-child(1) {
      width: 50%;
    }
    .tax-block:nth-child(2) {
      width: 50%;
    }
  }
`;

export const Drawers = styled.div`
  overflow: visible;

  .MuiListItem-root {
    padding: 0;
    border-bottom: solid 1px ${color('gray2')};
    flex-wrap: wrap;
  }

  .MuiButtonBase-root,
  .MuiCollapse-root {
    flex: 0 0 auto;
    width: 100%;
    max-width: 100%;
  }

  .MuiButtonBase-root {
    padding: 0;
  }

  .MuiListItemButton-root {
    &:hover {
      background-color: transparent;
    }
  }

  .MuiListItemText-primary {
    padding: ${space('xl')} 0;
    color: ${color('fg')};
    ${font('subhead-xs')};

    @media screen and (${query.atLeast('tablet')}) {
      ${font('subhead-lg')};
    }
  }

  .MuiCollapse-wrapper {
    padding-bottom: ${space('xl')};
  }
`;
